import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { CriarPessoaJuridica } from '@/features/proposta/services/criar-pessoa-juridica.service'
import type { TCreateContaResponse, TCreatePessoaJuridicaData } from '@/shared/interfaces/conta.types'

export const useMutationCadastrarPessoaJuridica = () => {
  return useMutation<TCreateContaResponse, AxiosError<string[]>, TCreatePessoaJuridicaData>({
    mutationFn: async (pessoaJuridica: TCreatePessoaJuridicaData) => {
      const response = await new CriarPessoaJuridica().execute(pessoaJuridica)
      return response
    },
  })
}
